import Vue from 'vue'
import comfirm from '../component/comfirm.vue'
import thanks from '../component/thanks.vue'
import detailService from '../service/detailService'

const CustomEvent = require('custom-event');

const vm = new Vue({
    el: '#detail',
    components: {
        thanks,
        comfirm
    },
    data(){
        return{
            step: 0,
            is_loading: false,
            activity_retail_id: '',
            rules: false,
            phoneNumber: '',
            coupon: {},
            countDown: {},
            area_code:"852"
        }
    },
    methods: {
        goNext(){
            this.step++
        },
        submitCoupon(){
            if(this.is_loading) return;
            this.is_loading = true;

            detailService.confirm({
                phone: this.area_code + this.phoneNumber,
                rules: this.rules ? 'true' : '',
                id: this.activity_retail_id
            })
            .then( resp => {
                let data = resp.data;

                if(resp.status){
                    this.coupon = data;
                    this.coupon.phone = this.area_code + this.phoneNumber;
                    this.countDown = {
                        phone: this.area_code + this.phoneNumber,
                        id: data.id,
                        ttl: data.ttl,
                        availableTimes: data.sms_times
                    };
                    const vPath = location.pathname.replace(/\/$/, '') + '/redemption';
                    history.pushState({}, '', vPath);
                    document.dispatchEvent(new CustomEvent("pageChange", {
                        detail: {
                            vPath: location.pathname
                        }
                    }));
                    this.step ++;
                }else{

                    const err = resp.error;
                    if(err.validate){
                        const first = Object.values(err.validate).find( item => item && item.length );
                        alert(first[0]);
                    }else{
                        alert(err.msg)
                    }
                }
            })
            .finally(() => {
                this.is_loading = false;
            })
        }
    }
})